<template>
  <div class="isTxt" v-if="isTxt">
    {{ name || '-' }}
  </div>
  <RxkRadio
    v-else
    :list="list"
    v-model="innerValue"
    @focus="remoteMethod"
    :disabled="renderConfig.disabled"
    :vertical="data.precisions === 1"
    v-bind="renderConfig"
  />
</template>
<script lang="ts" setup>
import { computed, onMounted, ref, unref, watch } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkRadio } from '@/components/common/RxkRadio'
import { getPageComponentData } from '@/apis/customerManage'
import { isNullOrUndefOrEmpty } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList'])

const innerValue = computed({
  get() {
    console.log(props.modelValue, 'props.modelValue222')
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const flag = ref(true)
const list = ref([])
const name = ref('')
onMounted(() => {
  if (props.data.dataMark !== 2) {
    list.value = props.renderConfig.dataList || []
    getName(list.value)
  } else {
    remoteMethod()
  }
})
function remoteMethod() {
  // console.log(props.data)
  if (unref(flag) && props.data.dataMark === 2) {
    const postData = {
      columnId: props.data.id,
      columnUseScene: props.data.columnUseScene,
      tableCode: props.data.tableCode
    }
    getPageComponentData(postData).then(res => {
      getName(res)
      list.value = res || []
      flag.value = false
      emit('refreshDataList', res)
    })
  }
}
function getName(list: Recordable[]) {
  console.log(innerValue, list, 'lolll')
  if (isNullOrUndefOrEmpty(list) || isNullOrUndefOrEmpty(innerValue.value)) {
    name.value = '-'
    return
  }
  const current = list.find(item => String(item.value) === String(innerValue.value))
  console.log(current, 'current222')
  name.value = current ? current.label || '-' : '-'
}

watch(
  () => props.isTxt,
  val => {
    if (val) {
      getName(list.value)
    }
  }
)
watch(
  () => innerValue.value,
  () => {
    getName(list.value)
  }
)

const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (_newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
